import * as React from 'react';
import { FC } from 'react';

import { useLoyaltyOffersUiIncentiveNotAvailableQuery } from 'generated/sanity-graphql';
import { maybeLocaleImages, maybeLocaleString } from 'utils/graphql';

import LoyaltyIncentiveNotAvailableModalView from './loyalty-incentive-not-available-modal.view';

interface LoyaltyIncentiveNotAvailableModalProps {
  isOffer?: boolean;
}

const LoyaltyIncentiveNotAvailableModal: FC<LoyaltyIncentiveNotAvailableModalProps> = ({
  isOffer,
}) => {
  const { data, loading } = useLoyaltyOffersUiIncentiveNotAvailableQuery({
    variables: { id: 'feature-loyalty-offers-ui-singleton' },
  });

  const content = isOffer
    ? data?.LoyaltyOffersUI?.offerNotAvailableModalContent
    : data?.LoyaltyOffersUI?.rewardNotAvailableModalContent;

  const image = maybeLocaleImages(content?.image);
  const title = maybeLocaleString(content?.title);
  const description = maybeLocaleString(content?.description);
  const primaryButtonText = maybeLocaleString(content?.primaryButton?.buttonText);
  const primaryButtonPath = maybeLocaleString(content?.primaryButton?.buttonPath);
  const secondaryButtonText = maybeLocaleString(content?.secondaryButton?.buttonText);
  const secondaryButtonPath = maybeLocaleString(content?.secondaryButton?.buttonPath);

  if (loading || !image || !title || !description || !primaryButtonText) {
    return null;
  }

  const defaultPath = '/';
  const actionButtons = [
    { buttonText: primaryButtonText, buttonPath: primaryButtonPath || defaultPath },
    {
      buttonText: secondaryButtonText || '',
      buttonPath: secondaryButtonPath || defaultPath,
      inverted: true,
    },
  ];

  return (
    <LoyaltyIncentiveNotAvailableModalView
      image={image}
      title={title}
      description={description}
      actionButtons={actionButtons}
    />
  );
};

export default LoyaltyIncentiveNotAvailableModal;
